// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import PassbookPage from './pages/PassbookPage';
import BillDetailPage from './pages/BillDetailPage';
import BillNamuna4HalfPage from "./pages/Billnamuna4halfpage";
// import DashboardPage from './pages/DashboardPage';
// import StudentPassbookPage from './pages/StudentPassbookPage';
import { requestForToken, onMessageListener } from "./firebase";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  // Listen for foreground FCM messages
  useEffect(() => {
    const unsubscribe = onMessageListener()
      .then(payload => {
        console.log("Foreground message:", payload);
        if (payload.notification) {
          alert(`🔔 ${payload.notification.title}\n${payload.notification.body}`);
        }
      })
      .catch(err => console.log("Failed to receive message:", err));

    // Cleanup if necessary
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  // Handler to request notification permission
  const enableNotifications = async () => {
    try {
      const permission = await Notification.requestPermission();
      console.log("Notification permission:", permission);

      if (permission === "granted") {
        setNotificationsEnabled(true);

        const token = await requestForToken();
        if (token) {
          console.log("Received FCM token:", token);
          // TODO: Send token to your backend if needed
        }
      } else {
        alert("Notifications are blocked. Please enable them in your browser settings.");
      }
    } catch (error) {
      console.error("Notification setup failed:", error);
    }
  };

  return (
    <Router>
      <div>
        {/* Button to enable notifications */}
        {!notificationsEnabled && (
          <button onClick={enableNotifications} style={{ margin: '10px', padding: '8px 16px' }}>
            Enable Notifications
          </button>
        )}
      </div>

      <Routes>
        {/* Login Page */}
        <Route
          path="/"
          element={<LoginPage onLogin={() => setIsAuthenticated(true)} />}
        />

        {/* Passbook Page */}
        <Route
          path="/passbook"
          element={isAuthenticated ? <PassbookPage /> : <Navigate to="/" />}
        />

        {/* Bill Detail Page */}
        <Route
          path="/bill/:username/:fromDate/:toDate"
          element={isAuthenticated ? <BillDetailPage /> : <Navigate to="/" />}
        />

        {/* Bill Namuna 4 Half Page */}
        <Route
          path="/billnamuna4half/:username/:fromDate/:toDate"
          element={isAuthenticated ? <BillNamuna4HalfPage /> : <Navigate to="/" />}
        />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
